// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-subtitle {
  /* height: 145px;*/
  background-color: var(--listsubtitles-card-subtitle-backcolor);
  color: black;
  border-radius: 6px;
  
}

.card-subtitle-canvas {
  /* height: 90px;*/
  /* width: calc(100% - 15px);
  margin: auto;*/
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: row;
}

.card-subtitle-top {
  height: 36px;
  font-size: 80%;
  display: flex;
  flex-direction: row;
  
}

.card-subtitle-top p {
  margin: 0 10px;
  align-content: center;
}

.card-subtitle-top .row {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.card-subtitle-top .col {
  /* width: auto;*/
  width: calc(100% / 4);
      margin: auto;
}

.card-subtitle-top .col-1 {
  width: auto;
  margin: auto 5px;
}

.card-subtitle-top .col.left * {
  text-align: left;
    margin: 0;
}

.card-subtitle-top .col.center * {
  text-align: center;
  justify-content: center;
}

.card-subtitle-top .col.right * {
  text-align: right;
    margin: auto;
  margin-right: 10px;
}

.card-subtitle-top .col.left,
.card-subtitle-top .col.right {
  .row:first-child {
    margin-bottom: 1px;
  }
}

.card-subtitle-top .checkbox {
  margin: 4px;
  display: flex;
  flex-direction: row;
}

.card-subtitle-top .checkbox.hide {
  display: none;
}

.card-subtitle-top .lisibility{
  margin-bottom: 8px;
  color: white;
  height: 32px;
  width:32px;
}

.card-subtitle-top .intervalles {
 /* display: flex;
  flex-direction: row;
  width: 100%;
  margin: auto;*/
}

.card-subtitle-top .intervalles .tooltip-wrapper {
  line-height: 0;
}

.card-subtitle-top .intervalles .icons {
  display: flex;
  margin: auto;
}

.card-subtitle-top .intervalles span,
.card-subtitle-top .timecode span {
  background-color: #2c2c2c;
  border-radius: 5px;
  padding: 0 10px;
}

.card-subtitle-top .timecode {
  font-size: 120%;
  /*margin-top: 3px;*/
}

.card-subtitle-top .white,
.card-subtitle-top .timecode .timecode-white,
.card-subtitle-top .intervalles .intervalle-white {
  color: #f5f5f5;
}

.card-subtitle-top .timecode .timecode-red,
.card-subtitle-top .intervalles .intervalle-red {
  color: #fe5953;
  font-weight: 700;
}

.card-subtitle-top .timecode .timecode-orange,
.card-subtitle-top .intervalles .intervalle-orange {
  color: #f57c00;
  font-weight: 700;
}

.card-subtitle-top .timecode.typing span {
  background-color: yellow;
  color: black !important;
}

.card-subtitle-top .subtitle-number {
  color: white;
  margin: auto;
  font-size: 100%;
}

.card-subtitle-top .small {
  font-size: 78%;
  margin: auto;
  color:white;
}

.card-subtitle-top .intervalles .small {
  font-size: 120%;
}

.card-subtitle-top span {
  vertical-align: middle;
}

.card-subtitle-canvas .column {
  display: inline-flex;
  flex-direction: row;
}



.card-subtitle-canvas .speaker {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  margin: 5px;
}

.card-subtitle-canvas .selection {
  align-content: end;
  margin-left: 5px;
}

.card-subtitle-canvas .selection .group {
  margin-right: 0;
  margin-bottom: 10px;
}

/*.card-subtitle-canvas .speaker button {
  padding: 5px;
  font-size: 80%;
  border-radius: 2em;
  width: 25px;
}*/

.card-subtitle-canvas .speaker button {
    font-size: 0.5rem;
    width: 100%;
    margin-bottom: 8px;
    padding: 1px;
    min-width: 18px;
}

.card-subtitle-canvas .length {
  width: 30px;
  color: white;
  margin: 5px auto;
  align-content: flex-end;
}

.card-subtitle-canvas .length p {
  padding: 5px;
  align-content: flex-end;
  font-size: 80%;
}

.card-subtitle-canvas .length p.error {
  color: red;
  font-weight: 700;
}

.card-subtitle-canvas .foreCanvas {
  
  height: 100%;
  cursor: text;
  background-color: #101010;
  border-radius: 5px;
  border-color: #353535;
  border-width: 1px;
  border-style: solid;
}

.active .card-subtitle-canvas .foreCanvas {
  background-color: black;
  border-radius: 5px;
  border-color: #FFFFFF;
  border-width: 3px;
  border-style: solid;
}

.sr-only {
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/subtitles/list-st/components/subtitle/subtitle.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8DAA8D;EAC9D,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;EACjB;gBACc;EACd,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;MACjB,YAAY;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;IACd,SAAS;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;IACf,YAAY;EACd,kBAAkB;AACpB;;AAEA;;EAEE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;CACC;;;gBAGe;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;EAKE;;AAEF;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EAEzC,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,8BAA8B;AAChC","sourcesContent":[".card-subtitle {\n  /* height: 145px;*/\n  background-color: var(--listsubtitles-card-subtitle-backcolor);\n  color: black;\n  border-radius: 6px;\n  \n}\n\n.card-subtitle-canvas {\n  /* height: 90px;*/\n  /* width: calc(100% - 15px);\n  margin: auto;*/\n  width: 100%;\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n}\n\n.card-subtitle-top {\n  height: 36px;\n  font-size: 80%;\n  display: flex;\n  flex-direction: row;\n  \n}\n\n.card-subtitle-top p {\n  margin: 0 10px;\n  align-content: center;\n}\n\n.card-subtitle-top .row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.card-subtitle-top .col {\n  /* width: auto;*/\n  width: calc(100% / 4);\n      margin: auto;\n}\n\n.card-subtitle-top .col-1 {\n  width: auto;\n  margin: auto 5px;\n}\n\n.card-subtitle-top .col.left * {\n  text-align: left;\n    margin: 0;\n}\n\n.card-subtitle-top .col.center * {\n  text-align: center;\n  justify-content: center;\n}\n\n.card-subtitle-top .col.right * {\n  text-align: right;\n    margin: auto;\n  margin-right: 10px;\n}\n\n.card-subtitle-top .col.left,\n.card-subtitle-top .col.right {\n  .row:first-child {\n    margin-bottom: 1px;\n  }\n}\n\n.card-subtitle-top .checkbox {\n  margin: 4px;\n  display: flex;\n  flex-direction: row;\n}\n\n.card-subtitle-top .checkbox.hide {\n  display: none;\n}\n\n.card-subtitle-top .lisibility{\n  margin-bottom: 8px;\n  color: white;\n  height: 32px;\n  width:32px;\n}\n\n.card-subtitle-top .intervalles {\n /* display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin: auto;*/\n}\n\n.card-subtitle-top .intervalles .tooltip-wrapper {\n  line-height: 0;\n}\n\n.card-subtitle-top .intervalles .icons {\n  display: flex;\n  margin: auto;\n}\n\n.card-subtitle-top .intervalles span,\n.card-subtitle-top .timecode span {\n  background-color: #2c2c2c;\n  border-radius: 5px;\n  padding: 0 10px;\n}\n\n.card-subtitle-top .timecode {\n  font-size: 120%;\n  /*margin-top: 3px;*/\n}\n\n.card-subtitle-top .white,\n.card-subtitle-top .timecode .timecode-white,\n.card-subtitle-top .intervalles .intervalle-white {\n  color: #f5f5f5;\n}\n\n.card-subtitle-top .timecode .timecode-red,\n.card-subtitle-top .intervalles .intervalle-red {\n  color: #fe5953;\n  font-weight: 700;\n}\n\n.card-subtitle-top .timecode .timecode-orange,\n.card-subtitle-top .intervalles .intervalle-orange {\n  color: #f57c00;\n  font-weight: 700;\n}\n\n.card-subtitle-top .timecode.typing span {\n  background-color: yellow;\n  color: black !important;\n}\n\n.card-subtitle-top .subtitle-number {\n  color: white;\n  margin: auto;\n  font-size: 100%;\n}\n\n.card-subtitle-top .small {\n  font-size: 78%;\n  margin: auto;\n  color:white;\n}\n\n.card-subtitle-top .intervalles .small {\n  font-size: 120%;\n}\n\n.card-subtitle-top span {\n  vertical-align: middle;\n}\n\n.card-subtitle-canvas .column {\n  display: inline-flex;\n  flex-direction: row;\n}\n\n\n\n.card-subtitle-canvas .speaker {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-end;\n  margin: 5px;\n}\n\n.card-subtitle-canvas .selection {\n  align-content: end;\n  margin-left: 5px;\n}\n\n.card-subtitle-canvas .selection .group {\n  margin-right: 0;\n  margin-bottom: 10px;\n}\n\n/*.card-subtitle-canvas .speaker button {\n  padding: 5px;\n  font-size: 80%;\n  border-radius: 2em;\n  width: 25px;\n}*/\n\n.card-subtitle-canvas .speaker button {\n    font-size: 0.5rem;\n    width: 100%;\n    margin-bottom: 8px;\n    padding: 1px;\n    min-width: 18px;\n}\n\n.card-subtitle-canvas .length {\n  width: 30px;\n  color: white;\n  margin: 5px auto;\n  align-content: flex-end;\n}\n\n.card-subtitle-canvas .length p {\n  padding: 5px;\n  align-content: flex-end;\n  font-size: 80%;\n}\n\n.card-subtitle-canvas .length p.error {\n  color: red;\n  font-weight: 700;\n}\n\n.card-subtitle-canvas .foreCanvas {\n  \n  height: 100%;\n  cursor: text;\n  background-color: #101010;\n  border-radius: 5px;\n  border-color: #353535;\n  border-width: 1px;\n  border-style: solid;\n}\n\n.active .card-subtitle-canvas .foreCanvas {\n  background-color: black;\n  border-radius: 5px;\n  border-color: #FFFFFF;\n  border-width: 3px;\n  border-style: solid;\n}\n\n.sr-only {\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  -webkit-clip-path: inset(50%) !important;\n  clip-path: inset(50%) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
